import classNames from "classnames";
import * as React from "react";
import "./HeroVideo.scss";
import { Countdown } from "../../components/Countdown";

interface IHeroVideoProps {}

export const HeroVideo: React.FunctionComponent<IHeroVideoProps> = (props) => {
  return (
    <div className={classNames("hero-video")}>
      <video
        autoPlay={true}
        playsInline={true}
        loop={true}
        muted={true}
        src="https://jd-ces-2022.s3.amazonaws.com/hero-video-yellow.mp4"
      ></video>
      <div className={classNames("hero-video__content")}>
        <h2>Exciting News Coming Tuesday, January 4, 2022</h2>
        <Countdown targetDate="2022-01-04T12:00:00-08:00" />
      </div>
    </div>
  );
};
